import { THEME } from 'reactor/common';

export default {
  COLOR: {
    ...THEME.COLOR,
    BACKGROUND: '#F9F9F9',
    BACKGROUND_ERROR: '#F9EAEC',
    SECONDARY: '#007A75',
  },
};
